import { render, staticRenderFns } from "./5-member-profile-extras.vue?vue&type=template&id=2f0a61ee&scoped=true"
import script from "./5-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./5-member-profile-extras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a61ee",
  null
  
)

export default component.exports